export class MapMarker {
  url: string;
  size: any;
  anchor: any;
}
